const splitByFirstOccurrence = (str: string, sep: string) => {
    const [first, ...rest] = str.split(sep);
    return [first, rest.join(sep)];
};
export default splitByFirstOccurrence;
